import { MODULES } from './licenseFeatures';

/**
 * Sidebar separators:
 * 1. Main gamme (Starter / Business / Enterprise)
 * 2. Industry optional add-ons
 * 3. Sector packs
 */
export const MODULE_LICENSE_TIERS = {
  STARTER: 'STARTER',
  BUSINESS: 'BUSINESS',
  ENTERPRISE: 'ENTERPRISE',
  INDUSTRY: 'INDUSTRY',
  SECTOR: 'SECTOR',
};

/** @type {Record<string, keyof typeof MODULE_LICENSE_TIERS>} */
export const MODULE_TIER_BY_KEY = {
  [MODULES.FACTURATION]: MODULE_LICENSE_TIERS.STARTER,
  [MODULES.VENTES]: MODULE_LICENSE_TIERS.STARTER,
  [MODULES.CRM]: MODULE_LICENSE_TIERS.STARTER,
  [MODULES.TACHES]: MODULE_LICENSE_TIERS.STARTER,

  [MODULES.ARTICLE]: MODULE_LICENSE_TIERS.BUSINESS,
  [MODULES.INVENTAIRE]: MODULE_LICENSE_TIERS.BUSINESS,
  [MODULES.RELATION_FOURNISSEUR]: MODULE_LICENSE_TIERS.BUSINESS,
  [MODULES.ACHATS]: MODULE_LICENSE_TIERS.BUSINESS,
  [MODULES.CAISSE]: MODULE_LICENSE_TIERS.BUSINESS,
  [MODULES.PROJETS]: MODULE_LICENSE_TIERS.BUSINESS,
  [MODULES.CONTRATS]: MODULE_LICENSE_TIERS.BUSINESS,
  [MODULES.MARKETING]: MODULE_LICENSE_TIERS.BUSINESS,
  [MODULES.SERVICE_CLIENT]: MODULE_LICENSE_TIERS.BUSINESS,
  [MODULES.APPROBATIONS]: MODULE_LICENSE_TIERS.BUSINESS,
  [MODULES.PLANIFICATION]: MODULE_LICENSE_TIERS.BUSINESS,

  [MODULES.RESSOURCES_HUMAINES]: MODULE_LICENSE_TIERS.ENTERPRISE,
  [MODULES.POINTAGE]: MODULE_LICENSE_TIERS.ENTERPRISE,
  [MODULES.SALAIRES]: MODULE_LICENSE_TIERS.ENTERPRISE,
  [MODULES.BANQUE]: MODULE_LICENSE_TIERS.ENTERPRISE,
  [MODULES.COMPTABILITE]: MODULE_LICENSE_TIERS.ENTERPRISE,
  [MODULES.TRESORERIE]: MODULE_LICENSE_TIERS.ENTERPRISE,
  [MODULES.BUDGET]: MODULE_LICENSE_TIERS.ENTERPRISE,
  [MODULES.PARC_AUTO]: MODULE_LICENSE_TIERS.ENTERPRISE,
  [MODULES.LOGISTIQUE]: MODULE_LICENSE_TIERS.ENTERPRISE,
  [MODULES.DISTRIBUTION]: MODULE_LICENSE_TIERS.ENTERPRISE,
  [MODULES.LIVRAISON]: MODULE_LICENSE_TIERS.ENTERPRISE,
  [MODULES.GESTION_SITUATION]: MODULE_LICENSE_TIERS.ENTERPRISE,

  [MODULES.PRODUCTION]: MODULE_LICENSE_TIERS.INDUSTRY,
  [MODULES.QUALITE]: MODULE_LICENSE_TIERS.INDUSTRY,
  [MODULES.POINT_DE_VENTE]: MODULE_LICENSE_TIERS.INDUSTRY,
  [MODULES.CONSTRUCTION]: MODULE_LICENSE_TIERS.INDUSTRY,
  [MODULES.MAINTENANCE]: MODULE_LICENSE_TIERS.INDUSTRY,
  [MODULES.IMPORT_EXPORT]: MODULE_LICENSE_TIERS.INDUSTRY,

  [MODULES.SECTOR_IMMOBILIER]: MODULE_LICENSE_TIERS.SECTOR,
  [MODULES.SECTOR_RESTAURANT]: MODULE_LICENSE_TIERS.SECTOR,
  [MODULES.SECTOR_VOYAGE]: MODULE_LICENSE_TIERS.SECTOR,
  [MODULES.SECTOR_AGRICULTURE]: MODULE_LICENSE_TIERS.SECTOR,
  [MODULES.SECTOR_CLINIQUE]: MODULE_LICENSE_TIERS.SECTOR,
  [MODULES.SECTOR_PHARMACIE]: MODULE_LICENSE_TIERS.SECTOR,
  [MODULES.SECTOR_LOCATION_FLOTTE]: MODULE_LICENSE_TIERS.SECTOR,
  [MODULES.SECTOR_EDUCATION]: MODULE_LICENSE_TIERS.SECTOR,
  [MODULES.SECTOR_ECOMMERCE]: MODULE_LICENSE_TIERS.SECTOR,
};

export function getModuleLicenseTier(moduleKey) {
  return MODULE_TIER_BY_KEY[moduleKey] || MODULE_LICENSE_TIERS.ENTERPRISE;
}

function isIndustryModule(moduleKey) {
  return getModuleLicenseTier(moduleKey) === MODULE_LICENSE_TIERS.INDUSTRY;
}

function isSectorModule(moduleKey) {
  return getModuleLicenseTier(moduleKey) === MODULE_LICENSE_TIERS.SECTOR;
}

function isMainGammeModule(moduleKey) {
  const tier = getModuleLicenseTier(moduleKey);
  return (
    tier === MODULE_LICENSE_TIERS.STARTER ||
    tier === MODULE_LICENSE_TIERS.BUSINESS ||
    tier === MODULE_LICENSE_TIERS.ENTERPRISE
  );
}

/** Gray section title before the first Starter / Business / Enterprise module. */
export function shouldShowMainGammeSectionHeader(moduleKey, filteredModuleKeys) {
  const firstMainIndex = filteredModuleKeys.findIndex(isMainGammeModule);
  if (firstMainIndex < 0) return false;
  return filteredModuleKeys[firstMainIndex] === moduleKey;
}

/** Pale gray line before the first Industry add-on module. */
export function shouldShowMainGammeSeparator(moduleKey, filteredModuleKeys) {
  const firstIndustryIndex = filteredModuleKeys.findIndex(isIndustryModule);
  if (firstIndustryIndex <= 0) return false;
  return filteredModuleKeys[firstIndustryIndex] === moduleKey;
}

/** Pale gray line before the first Sector pack module. */
export function shouldShowIndustrySectorSeparator(moduleKey, filteredModuleKeys) {
  const firstSectorIndex = filteredModuleKeys.findIndex(isSectorModule);
  if (firstSectorIndex <= 0) return false;
  return filteredModuleKeys[firstSectorIndex] === moduleKey;
}
